import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=aa7c0af4&scoped=true"
import script from "./OrderAddress.vue?vue&type=script&lang=js"
export * from "./OrderAddress.vue?vue&type=script&lang=js"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=aa7c0af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7c0af4",
  null
  
)

export default component.exports